import filter from 'lodash/filter.js';
import sortBy from './sortBy.js';

const getToAndFromPrice = (pricesPerQ) => {
  sortBy(pricesPerQ, (_) => [_.year, _.quarter]);
  const toPrice = pricesPerQ[pricesPerQ.length - 1];
  const { year: currentYear, quarter: currentQuarter } = toPrice;
  const [fromPrice] = filter(pricesPerQ, { year: currentYear - 1, quarter: currentQuarter });
  return { toPrice, fromPrice };
};

export default getToAndFromPrice;
